module.exports = __webpack_public_path__ + "static/media/menu_transactionFees_hoverActive.7a2c03ad.svg";